
import React from 'react';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';

import DevelopmentVersion from '../common/client/components/mysliveckyportal/DevelopmentVersion';
import OperationStatus from '../common/client/components/OperationStatus';
import Routes from '../common/client/components/Routes';
import useCheckSession from '../common/client/hooks/mysliveckyportal/useCheckSession';

import usePageTracking from './usePageTracking';

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/');

const App = (props) => {

    useCheckSession();
    usePageTracking();

    return (
        <>
            <Routes routes={props.routes} />
            <OperationStatus />
            <DevelopmentVersion />
        </>
    );
};

export default App;
